import { useMutation } from "@tanstack/react-query";

import { previewRdoPdf } from "@/adapters/api";

export function useRdoPreview(
	constructionId: string | undefined,
	rdoId: string | undefined,
) {
	return useMutation({
		mutationFn: async () => {
			if (!constructionId || !rdoId) throw new Error("missing rdo");
			const blob = await previewRdoPdf(constructionId, rdoId);
			return URL.createObjectURL(
				blob.type === "application/pdf"
					? blob
					: new Blob([blob], { type: "application/pdf" }),
			);
		},
	});
}
